import React, { createContext, useState, useEffect } from 'react';
import axiosInstance, { setNavigate } from '../axiosConfig';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        setNavigate(navigate);

        const fetchUserData = async () => {
            const storedAuth = localStorage.getItem('auth');
            if (storedAuth) {
                const authData = JSON.parse(storedAuth);
                setAuth(authData);

                try {
                    const response = await axiosInstance.get('/api/users/', {
                        headers: {
                            Authorization: `Bearer ${authData.accessToken}`
                        }
                    });
                    const { users: fetchedUsers, isAdmin } = response.data;
                    setUsers(fetchedUsers);
                    setAuth({ ...authData, isAdmin }); // Update auth context with isAdmin status
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        await refreshAccessToken(authData.refreshToken);
                    } else {
                        // console.error('Failed to fetch users:', error);
                        setAuth(null);
                    }
                }
            } else {
                setAuth(null);
            }
            setLoading(false);
        };

        fetchUserData();
    }, []);

    const refreshAccessToken = async (refreshToken) => {
        try {
            const response = await axiosInstance.post('/api/auth/refresh-token', { refreshToken });
            const { accessToken } = response.data;
            setAuth(prevAuth => ({ ...prevAuth, accessToken }));
            localStorage.setItem('auth', JSON.stringify({ ...auth, accessToken }));
        } catch (error) {
            // console.error('Failed to refresh token:', error);
            logout();
        }
    };

    const login = (user, accessToken, refreshToken, invitationLink) => {
        const authData = {
            ...user,
            accessToken,
            refreshToken,
            invitationLink
        };

        setAuth(authData);
        localStorage.setItem('auth', JSON.stringify(authData));
        navigate('/');
    };

    const logout = () => {
        setAuth(null);
        setUsers([]); // Clear users when logging out
        localStorage.removeItem('auth');
        localStorage.removeItem('tx_ref');
        localStorage.removeItem('referralCode');

        navigate('/login');
    };

    return (
        <AuthContext.Provider value={{ auth, loading, users, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
